import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable()
export class LoadingProvider {
  waitText: string = 'Παρακαλώ Περιμένετε...';

  constructor(public loadingCtrl: LoadingController) {
    // console.log('Hello LoadingProvider Provider');
  }

  async create() {
    return await this.loadingCtrl.create({
      message: this.waitText,
    });
  }
}
